export const getUniqueInterestedUsers = (featureInterest, currentUserEmail) => {
  if (!featureInterest) return [];
  const emailCounts = {};
  let currentUserInfo = null;

  for (const feature of featureInterest) {
    if (!feature.hubSpotUserInfo) continue;

    for (const user of feature.hubSpotUserInfo) {
      if (user.email !== currentUserEmail) {
        if (emailCounts[user.email]) {
          emailCounts[user.email].count += 1;
        } else {
          emailCounts[user.email] = {
            count: 1,
            user
          };
        }
      } else if (!currentUserInfo) {
        currentUserInfo = user;
      }
    }
  }

  const sortedUsers = Object.values(emailCounts).sort((a, b) => b.count - a.count).map(info => info.user);

  if (currentUserInfo) {
    sortedUsers.push(currentUserInfo);
  }

  return sortedUsers;
};